<template>
  <div>
    <v-btn
      :color="color"
      class="text-white"
      @mousedown="start"
      @mouseleave="stop"
      @mouseup="stop"
      @touchstart="start"
      @touchend="stop"
      @touchcancel="stop"
    >
      <v-progress-circular
        class="mr-2"
        :size="20"
        :rotate="-90"
        :value="progress"
        :width="3"
        color="white"
      />
      {{ label }}
    </v-btn>
  </div>
</template>
<script>
export default {
  name: 'ButtonHoldToConfirm',
  props: {
    seconds: { type: Number, default: 2, min: 1 },
    color: { type: String, default: 'primary' },
    label: { type: String, required: true },
  },
  data: () => ({
    interval: false,
    timeout: false,
    count: 0,
    progress: 0,
  }),
  methods: {
    start(event) {
      if (!this.interval) {
        const intervalMs = 200;
        const animatedExaggerator = 0.4 / this.seconds;
        clearTimeout(this.timeout);
        this.timeout = false;
        this.count = 0;
        this.progress = 0;
        this.interval = setInterval(() => {
          this.progress = (this.count / this.seconds) * 100 + animatedExaggerator;
          if (this.count > this.seconds) {
            this.$emit('confirmed');
            this.stop();
          }
          this.count += intervalMs / 1000;
        }, intervalMs);
      }
    },
    stop(event) {
      clearInterval(this.interval);
      this.interval = false;
      this.$emit('cancelled');
      this.timeout = setTimeout(() => {
        this.count = 0;
        this.progress = 0;
      }, (this.seconds * 1000) / 2);
    },
  },
};
</script>
